import { Box, Skeleton, styled } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';

const SkeletonMainCategoriesMobileCategory = styled(Skeleton)(({ theme }) => ({
  margin: theme.spacing(0, 3, 1),
  minWidth: '80%',
}));

const SkeletonMainCategoriesMobileCategoryLarge = styled(Skeleton)(({ theme }) => ({
  margin: theme.spacing(5, 3, 1),
  minWidth: '80%',
}));

const SKELETON_HEIGHT = 60;

export const SkeletonMainCategoriesMobile = () => {
  const elements = Math.floor(window.innerHeight / SKELETON_HEIGHT);
  const steps = Array.from({ length: elements }, (element, index) => index);
  const { getTestId } = useTestId();

  const skeletonElements = steps.map((step) => (
    <SkeletonMainCategoriesMobileCategory
      key={`categories-mobile-${step}`}
      height={37}
      animation="wave"
      variant="rectangular"
    />
  ));

  return (
    <Box data-testid={getTestId('skeleton-main-category-mobile')}>
      <SkeletonMainCategoriesMobileCategory
        key="categories-mobile-medium"
        height={54}
        animation="wave"
        variant="rectangular"
      />

      {skeletonElements}

      <SkeletonMainCategoriesMobileCategoryLarge
        key="categories-mobile-large"
        height={109}
        animation="wave"
        variant="rectangular"
      />
    </Box>
  );
};
